<mat-toolbar class="mat-primary">
  <span class="fill-remaining-space">Passwort zurücksetzen</span>
  <mat-icon class="cursor-mat-element" (click)="closeModal(false)">close</mat-icon>
</mat-toolbar>

<mat-dialog-content>
  <form [formGroup]="formGroup" class="form">
    <div *ngIf="message" style="padding: 15px" [ngClass]="{ 'text-error': error }">
      <p>{{ message }}</p>
    </div>

    <div class="form-element" *ngIf="isUserMail">
      Bitte tragen Sie nachstehend Ihre E-Mail-Adresse ein. Wir schicken Ihnen einen Link zu, um Ihr Passwort
      zurückzusetzen.
    </div>

    <div class="form-element" *ngIf="isPassword">Bitte geben Sie Ihr Passwort ein.</div>

    <mat-form-field class="form-element" *ngIf="isUserMail">
      <input matInput placeholder="E-Mail-Adresse" formControlName="username" />
      <mat-error *ngIf="!formGroup.controls['username'].valid && formGroup.controls['username'].touched">
        {{ validatorsService.getErrorMail(formGroup, 'username') }}
      </mat-error>
    </mat-form-field>

    <mat-form-field class="form-element" appearance="fill" *ngIf="isPassword">
      <mat-label>Passwort</mat-label>
      <input matInput [type]="hide ? 'password' : 'text'" formControlName="password" />
      <mat-icon matSuffix (click)="hide = !hide">
        {{ hide ? 'visibility_off' : 'visibility' }}
      </mat-icon>
      <mat-error *ngIf="!formGroup.controls['password'].valid && formGroup.controls['password'].touched">
        {{ validatorsService.getErrorPassword(formGroup, 'password') }}
      </mat-error>
    </mat-form-field>
    <div class="button-container">
      <div class="spinner-container" *ngIf="isLoading">
        <mat-spinner [color]="color" diameter="24"></mat-spinner>
      </div>
      <button
        mat-raised-button
        class="button-100"
        color="primary"
        id="requestPassword"
        *ngIf="isUserMail"
        [disabled]="!formGroup.valid"
        (click)="requestNewPassword()">
        Passwort anfordern
      </button>
      <button
        mat-raised-button
        class="button-100"
        color="primary"
        id="login"
        *ngIf="isPassword"
        [disabled]="!formGroup.valid"
        (click)="changePassword()">
        Passwort ändern
      </button>
    </div>

    <mat-grid-list cols="2" rowHeight="2:0.5">
      <mat-grid-tile *ngIf="error">
        <button mat-raised-button id="modal-cancel-button" (click)="closeModal(false)" color="warn">
          cancel
        </button>
      </mat-grid-tile>
      <mat-grid-tile *ngIf="isOk">
        <button mat-raised-button id="modal-ok-button" color="primary" (click)="closeModal(true)">ok</button>
      </mat-grid-tile>
    </mat-grid-list>
  </form>
</mat-dialog-content>
